var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarBlackOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.571,
    viewBox: "0 0 20 18.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star_black_outline",
    "data-name": "star black outline",
    d: "M21.491,9.8H14.924l-2-5.955a.723.723,0,0,0-1.357,0l-2,5.955H2.964a.716.716,0,0,0-.714.714.525.525,0,0,0,.013.121.686.686,0,0,0,.3.5l5.4,3.8L5.888,20.969a.716.716,0,0,0,.246.8.691.691,0,0,0,.4.174.875.875,0,0,0,.446-.161l5.268-3.754,5.268,3.754a.837.837,0,0,0,.446.161.641.641,0,0,0,.4-.174.708.708,0,0,0,.246-.8l-2.071-6.022,5.353-3.839L22.018,11a.749.749,0,0,0,.232-.478A.756.756,0,0,0,21.491,9.8Zm-5.679,4.129a1.254,1.254,0,0,0-.455,1.42L16.7,19.268a.179.179,0,0,1-.272.205l-3.455-2.464a1.247,1.247,0,0,0-.728-.232,1.224,1.224,0,0,0-.723.232l-3.455,2.46a.179.179,0,0,1-.272-.205l1.344-3.915a1.258,1.258,0,0,0-.46-1.429L5.062,11.371a.179.179,0,0,1,.1-.326H9.571a1.248,1.248,0,0,0,1.183-.853l1.321-3.937a.18.18,0,0,1,.339,0l1.321,3.937a1.248,1.248,0,0,0,1.183.853h4.344a.177.177,0,0,1,.1.321Z",
    transform: "translate(-2.25 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlackOutline);
export default __webpack_public_path__ + "static/media/star-black-outline.f5c5d7aadaccb8712346380c9c3505e5.svg";
export { ForwardRef as ReactComponent };